import React from 'react'
import { Link } from 'react-router-dom'

import {
  getSinglarOrPluralWord,
  timezones,
  sort,
} from '../../utilities/helpers'

import Card from 'react-bootstrap/Card'
import Stack from 'react-bootstrap/Stack'
import Button from 'react-bootstrap/Button'
import Badge from 'react-bootstrap/Badge'

import { PackageEvent } from './../PackageEvent'
import { InfoIcon } from '../InfoIcon'

import './packageEventList.scss'

export function hasEventEnded(event) {
  // event has ended
  return event?.status === 'complete'
}

// reusable component in my package page and package details popup
export default function PackageEventList({ events, linkTo, orderId }) {
  if (!events) return

  const timezone = timezones(
    events[0]?.venue?.timezone || events[0]?.event?.venue?.timezone
  )

  const getItem = (event, venue) => {
    const eventObj = event?.event || event
    // if link and event has tickets - will be empty if all tickets are transferred
    // Allow wallet access whenever the holder still has tickets for the event.
    if (linkTo && event?.tickets?.length > 0) {
      return (
        <Link to={`${linkTo}/event/${eventObj?.uuid}`}>
          <PackageEvent
            event={eventObj}
            venue={venue}
            timezone={timezone}
            styles="hover-effect card-list--light card-list--dark-border"
          >
            <Button
              id="details-btn"
              variant="outline-light"
              size="sm"
              className="m-0 d-flex align-items-center gap-2"
            >
              <InfoIcon />
              <span className="tablet-desktop-only">Details</span>
            </Button>
          </PackageEvent>
        </Link>
      )
    } else {
      return (
        <PackageEvent
          event={eventObj}
          venue={venue}
          timezone={timezone}
          styles={linkTo ? 'card-list--light card-list--dark-border' : ''}
        >
          {linkTo && !hasEventEnded(eventObj) && (
            <Badge btn="secondary">Transferred</Badge>
          )}
        </PackageEvent>
      )
    }
  }
  return (
    <section id="package-event-list">
      <Card body className="card-xl card-xl--dark">
        <div className="mb-3">
          <Card.Title
            as="h5"
            className="card-title-sm card-title--uppercase mb-2"
          >
            Events List
          </Card.Title>
          <Card.Subtitle>
            This plan includes {events?.length}{' '}
            {getSinglarOrPluralWord(events?.length, 'event')}. See the confirmed
            events and their details below.
          </Card.Subtitle>
        </div>
        <Stack as="ul" gap={2}>
          {sort(events, 'event')?.map((event, idx) => (
            <li key={idx}>
              {getItem(event, event?.event?.venue || event?.venue)}
            </li>
          ))}
        </Stack>
      </Card>
    </section>
  )
}
